import React from "react";

export const RightSidebar = () => (
  <aside className="col-8 right-sidebar">
    <div id="hcard-main-contact" className="vcard dark-background">
      <h2 className="h1-style">Need Help?</h2>
      <p className="body-bold">Mailing Address</p>
      <div className="adr">
        <p className="org">
          <span className="organization-name">
            Virginia Department of Corrections
          </span>
          <br />
          <span className="organization-unit">Visitation Unit</span>
          <br />
        </p>{" "}
        <span className="post-office-box">P.O. Box 26963</span>
        <br />
        <span className="locality">Richmond,&nbsp;</span>
        <span className="region">VA&nbsp;</span>
        <span className="postal-code">23261</span>
      </div>
      <p className="body-bold">Email</p>
      <a className="email" href="mailto:VisitationInquiries@vadoc.virginia.gov">
        VisitationInquiries@&#8203;vadoc.virginia.gov
      </a>
      <div className="tel">
        <p className="value">(804) 887-8341</p>
      </div>
    </div>
  </aside>
);



// WEBPACK FOOTER //
// ./src/components/RightSidebar/RightSidebar.js